import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * FINA-2611: normaliza el DISPLAY de un input numérico en el blur, quitando cualquier
 * cero a la izquierda que quede al pegar un valor (ej. "09" -> "9"). El FormControl casi
 * siempre ya tiene el número correcto (el value accessor lo parsea con parseFloat en cada
 * `input`), pero el DOM conserva el texto pegado tal cual hasta que algo lo reescribe.
 *
 * Se dispara un evento `input` real tras corregir el `value` para que el
 * formControlName/ngModel del host quede sincronizado, sin necesidad de inyectar
 * NgControl ni de un handler por componente.
 */
@Directive({
    selector: 'input[type=number][finaTrimLeadingZero]',
})
export class TrimLeadingZeroDirective {
    constructor(private el: ElementRef<HTMLInputElement>) {}

    @HostListener('blur')
    onBlur(): void {
        const input = this.el.nativeElement;
        if (input.value === '') return;
        const numericValue = Number(input.value);
        if (!Number.isFinite(numericValue)) return;
        const normalized = String(numericValue);
        if (input.value === normalized) return;
        input.value = normalized;
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
}
